import { BritishColumbiaObstetricalFileIndigenousIdentity } from "./BritishColumbiaObstetricalFileIndigenousIdentity";
import { BritishColumbiaObstetricalFilePartnerInformation } from "./BritishColumbiaObstetricalFilePartnerInformation";

class BritishColumbiaObstetricalFilePatientInformation {
    public PrimaryMaternityCareProviderName: string = "";
    public FamilyPhysicianOrNursePractitionerName: string = "";
    public AgeAtEstimatedDateOfDelivery: number = null;
    public SurnameAtBirth: string = "";
    public PreferredNamePronoun: string = "";
    public PreferredLanguage: string = "";
    public RelationshipStatus: string = "";
    public HighestLevelEducationCompleted: string = "";
    public Occupation: string = "";
    public IndigenousIdentity: BritishColumbiaObstetricalFileIndigenousIdentity;
    public Ethnicity: string = "";
    public PartnerInformation: BritishColumbiaObstetricalFilePartnerInformation;

    public constructor(fields?: Partial<BritishColumbiaObstetricalFilePatientInformation>) {
        Object.assign(this, fields);
        this.IndigenousIdentity = new BritishColumbiaObstetricalFileIndigenousIdentity(fields?.IndigenousIdentity);
        this.PartnerInformation = new BritishColumbiaObstetricalFilePartnerInformation(fields?.PartnerInformation);
    }
}

export { BritishColumbiaObstetricalFilePatientInformation };
